import React from 'react';
import {
  Button,
  Confirm,
  Form,
  Header,
  Icon,
  Message,
  Dimmer,
  Loader,
  Image,
} from 'semantic-ui-react';
import { inlineStyle } from '../../styles/custom';
import FileUploadButton from '../fileUploadButton';

const GhdSocialNetworkForm = ({
  obj,
  status,
  onChange,
  onSubmit,
  onDelete,
}) => {
  if (status.loading)
    return (
      <Dimmer active inverted>
        <Loader inverted>Chargement</Loader>
      </Dimmer>
    );
  return (
    <Form>
      <Header>Catégories{status.isNew ? ' : Création' : ' : Édition'}</Header>
      {status.error ? (
        <Message negative>
          <Message.Header>Erreur</Message.Header>
          <p>{status.message}</p>
        </Message>
      ) : null}
      {!status.error && status.message ? (
        <Message info>
          <p>{status.message}</p>
        </Message>
      ) : null}

      <Form.Field>
        <label>Nom du réseau social</label>
        <Form.Input
          placeholder="URL"
          id="name"
          value={obj.name || ''}
          onChange={(e) => onChange(e)}
        />
      </Form.Field>
      <Form.Field>
        <label>URL ciblé</label>
        <Form.Input
          placeholder="URL"
          id="url"
          value={obj.url || ''}
          onChange={(e) => onChange(e)}
        />
      </Form.Field>
      <Form.Group widths="equal">
        <Form.Field>
          {typeof obj.icon_light === 'string' ? (
            <Image src={obj.icon_light} size="tiny" />
          ) : null}
          <FileUploadButton
            id="icon_light"
            label="Icone clair"
            onChange={onChange}
          />
        </Form.Field>
        <Form.Field>
          {typeof obj.icon_dark === 'string' ? (
            <Image src={obj.icon_dark} size="tiny" />
          ) : null}
          <FileUploadButton
            id="icon_dark"
            label="Icone foncé"
            onChange={onChange}
          />
        </Form.Field>
      </Form.Group>

      <br />
      {status.loading ? (
        <Button type="submit" color="olive" loading></Button>
      ) : (
        <Button type="submit" color="olive" floated="left" onClick={onSubmit}>
          <Icon name="save" /> Sauvegarder
        </Button>
      )}
      {!status.isNew ? (
        <div>
          <Button
            type="submit"
            color="red"
            floated="right"
            onClick={(event, data) => {
              onDelete(event, { confirm: true });
            }}
          >
            <Icon name="delete" /> Suppression
          </Button>
        </div>
      ) : null}
      <Confirm
        content="Êtes-vous sûr(e) de vouloir supprimer ce réseau social ? Cette action est définitive."
        open={status.deletion.confirm}
        onCancel={(event, data) => {
          onDelete(event, { confirm: null });
        }}
        onConfirm={(event, data) => {
          onDelete(event, { confirm: false });
        }}
        style={inlineStyle.modal}
      />
    </Form>
  );
};

export default GhdSocialNetworkForm;



// WEBPACK FOOTER //
// ./src/components/form/GhdSocialNetwork.js